const locationsByProvince = [
  {
    province: "Badajoz",
    locations: [
      {
        name: "Monesterío",
        contact: "Ana",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      }
    ]
  },
  {
    province: "Cádiz",
    locations: [
      {
        name: "Arcos de la Frontera",
        contact: "Javi",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      }
    ]
  },
  {
    province: "Huelva",
    locations: [
      {
        name: "Cortegana",
        contact: "Israel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Palma del Condado",
        contact: "Israel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Santa Olalla del Cala",
        contact: "Ana",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      }
    ]
  },
  {
    province: "Málaga",
    locations: [
      {
        name: "Campillos",
        contact: "Javi",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      }
    ]
  },
  {
    province: "Sevilla",
    locations: [
      {
        name: "Alcalá del Río",
        contact: "Miguel Ángel",
        phone: "+34 621 234 462",
        link: "https://maps.app.goo.gl/Fh2oJwYwaE9nYrsg8",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Brenes",
        contact: "Javi",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Burguillos",
        contact: "Miguel Ángel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Camas",
        contact: "Ana",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Cantillana",
        contact: "Javi",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Cañada Rosal",
        contact: "Mª José",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Carmona",
        contact: "Mª José",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Coria del Río",
        contact: "José Luis",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Gerena",
        contact: "Israel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Guillena",
        contact: "José Manuel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "La Luisiana",
        contact: "Mª José",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "La Macarena",
        contact: "José María",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "La Rinconada",
        contact: "Miguel Ángel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Lora del Río",
        contact: "Javi",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Parque Alcosa",
        contact: "José Manuel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Pino Montano",
        contact: "José María",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Real de la Jara",
        contact: "Ana",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "San Jerónimo",
        contact: "José Luis",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "San José",
        contact: "José Manuel",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      },
      {
        name: "Villaverde del Río",
        contact: "Javi",
        phone: "+34 621 234 462",
        services: ["Psicología", "Naturopatía Alimentaria"]
      }
    ]
  },
  {
    province: "Online",
    locations: [
      {
        name: "Online",
        contact: "Norberto",
        phone: "+34 621 234 463",
        services: ["Psicología", "Naturopatía Alimentaria"]
      }
    ]
  }
];

export default locationsByProvince;
